//@ts-nocheck

'use client'

import React, { createContext, useState } from "react";

export const MouseContext = createContext({
  cursorType: "",
  cursorText: "",
  cursorColorScheme: null,
  cursorChangeHandler: (cursorType: string) => {},
  cursorChangeText: (cursorText: string) => {},
  cursorChangeColorScheme: (cursorColorScheme: string | null) => {},
});

const MouseProvider = (props) => {
  const [cursorType, setCursorType] = useState("");
  const [cursorText, setCursorText] = useState("");
  const [cursorColorScheme, setCursorColorScheme] = useState(null);

  const cursorChangeHandler = (cursorType: string) => {
    setCursorType(cursorType);
  };

  const cursorChangeText = (cursorText: string) => {
    setCursorText(cursorText);
  };

  const cursorChangeColorScheme = (cursorColorScheme: string | null) => {
    setCursorColorScheme(cursorColorScheme);
  };

  return (
    <MouseContext.Provider
      value={{
        cursorText,
        cursorType,
        cursorColorScheme,
        cursorChangeHandler,
        cursorChangeText,
        cursorChangeColorScheme,
      }}
    >
      {props.children}
    </MouseContext.Provider>
  );
};

export default MouseProvider